import "../styles/Form.css";

function Form() {
    return (
        <div className="form__section">
            <h1>CONTACT US</h1>
            <form name="contact" method="post" id="form">
            <input type="hidden" name="form-name" value="contact" />
                <div>
                    <label>Your Name</label>
                    <br></br>
                    <input type="text" name="name" required="required"></input>
                </div>
                <div>
                    <label>Your Email</label>
                    <br></br>
                    <input type="email" name="email" required="required"></input>
                </div>
                <div>
                    <label>Your Message</label>
                    <br></br>
                    <textarea required="required" name="message" className="message"></textarea>
                </div>
                <div>
                    <button type="submit">SUBMIT</button>
                </div>
            </form>
        </div>
    );
}

export default Form;
